import React, { useEffect, useState } from 'react';
import CardExpertise from '../../Components/CardExpertise/CardExpertise';
import './NosPrestations.css';
import social from "../../Assets/Icons/social.svg";
import social2 from "../../Assets/Icons/social2.svg";
import socialImg from "../../Assets/Images/IMG_2.jpg";
import ButtonContactUs from '../../Components/ButtonContactUs/ButtonContactUs';
import SectionTitle from '../../Components/SectionTitle/SectionTitle';
import CardJuridique from '../../Components/CardJuridique/CardJuridique';
import CardFiscale from '../../Components/CardFiscale/CardFiscale';
import vieSocial from '../../Assets/Icons/vie-social.svg';
import liquidation from '../../Assets/Icons/liquidation.svg';
import optimisation from '../../Assets/Icons/optimisation.svg';
import etablissement from '../../Assets/Icons/etablisssement.svg';
import verification from '../../Assets/Icons/vérification.svg';
import conseilFiscal from '../../Assets/Icons/conseil-fiscal.svg';
import entrepriseEnDifficulte from '../../Assets/Icons/entreprise-en-difficulté.svg';

const NosPrestations = () => {

  const [largeurCard, setLargeurCard] = useState(0)

  useEffect(() => {
    const handleResize = () => {
      setLargeurCard(document.querySelector('.card-juridique').clientWidth);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className='nosPrestations-container'>
      <h1>Nos expertises</h1>

      {/* -----------  SECTION 1  ----------- */}
      <section className='area-of-expertise'>
        <CardExpertise title="Mission Fiscale" backgroundColor="background-dark" anchor="#mission-fiscale" illustration={etablissement}>
          Nous prenons en charge l'élaboration de vos déclarations fiscales de toutes natures.
        </ CardExpertise>
        <CardExpertise title="Sociale" backgroundColor="background-regular" anchor="#social" illustration={social2}>
          Nous prenons en charge l'élaboration de vos déclarations fiscales de toutes natures.
        </ CardExpertise>
        <CardExpertise title="Juridique" backgroundColor="background-light" anchor="#juridique" illustration={etablissement}>
          Nous prenons en charge l'élaboration de vos déclarations fiscales de toutes natures.
        </ CardExpertise>
      </section>

      {/* -----------  SECTION 2  ----------- */}
      <section className='mission-fiscales'>
        <SectionTitle title="Missions Fiscales" backgroundImage="background-1" id="mission-fiscale" />

        <div className='mission-fiscales-description'>
          <p>Dans le cadre de la nouvelle réglementation, nous assistons également les particuliers dans l'élaboration des différentes déclarations fiscales qu'ils sont amenés à produire pour l'administration.</p>
        </div>

        <div className='mission-fiscales-details'>
          <CardFiscale title="Etablissement" illustration={etablissement}>
            <ul className='cardFiscale-list'>
              <li><span className='puce-list'>.</span> De la liasse fiscale</li>
              <li><span className='puce-list'>.</span> Des déclarations fiscales, (TVA, CET, CVAE, DES, etc...).</li>
            </ul>
          </CardFiscale>
          <CardFiscale title="Vérification" illustration={verification}>
            <ul className='cardFiscale-list'>
              <li><span className='puce-list'>.</span> De la cohérence entre la fiscalité de l’entreprise et le statut des dirigeants</li>
              <li><span className='puce-list'>.</span> Du traitement des frais mixtes personnels et professionnels</li>
              <li><span className='puce-list'>.</span> Des possibilités d’application des exonérations spécifiques (Jeunes entreprises innovantes, zones franches urbaines, zones de revitalisation rurale)</li>
            </ul>
            <p style={{marginTop: "1rem"}}>Recherche des possibilités de crédits d’impôts (formation, recherche, innovation…)</p>
          </CardFiscale>
          <CardFiscale title="Conseil fiscal" illustration={conseilFiscal}>
            <p>Qu’il s’agisse de fiscalité personnelle ou professionnelle, nous vous proposons de vous porter conseil en matière de fiscalité en faisant intervenir si nécessaire d’autres professionnels avec lesquels nous sommes partenaires.</p>
          </CardFiscale>
        </div>

        <ButtonContactUs />
      </section>

      {/* -----------  SECTION 3  ----------- */}
      <section className='social'>
        <SectionTitle title="Social" backgroundImage="background-2"  id="social" />

        <div className='social-description'>
          <img src={socialImg} alt="illustration social" />
          <div className='social-description-container'>
            <div className='social-description-title'>
              <img src={social} alt="pictos social" />
              <h3>MISSIONS EFFECTUEES AU SEIN DE NOTRE CABINET</h3>
            </div>
            <ul className='social-description-content'>
              <li>Définir la convention collective dont dépend l'entreprise</li>
              <li>Etablissement des contrats de travail</li>
              <li>Etablissement des bulletins de paie et soldes de tout compte</li>
              <li>Etablissement des déclarations sociales prériodiques</li>
              <li>Etudier avec soin les éléments complémentaires aux salaires</li>
              <li>Epargne entreprise</li>
              <li>Retraite complémentaire</li>
              <li>Mutuelle complémentaire</li>
              <li>Liste des avantages en nature réintégrables</li>
              <li>L'accompagnement lors des contrôles et litiges sociaux</li>
            </ul>
            <ButtonContactUs />
          </div>
        </div>
      </section>

      {/* -----------  SECTION 4  ----------- */}
      <section className='juridique'>
        <SectionTitle  title="Juridique" backgroundImage="background-3" id="juridique" />
        <div className='juridique-content'>
          <CardJuridique 
            backgroundColor="true" 
            title={<h3 className='card-juridique-title font-white'>En cours de vie sociale</h3>} 
            icon={vieSocial} 
          >
            <ul className="card-juridique-content font-white" >
                <li>Négociation des finacements bancaires</li>
                <li>Etablissement d'un Business Plan</li>
                <li>Assistance à l'acquisition d'entreprise ou de fonds de commerce</li>
                <li>Recherche / Négociation des financements bancaires</li>
                <li>Etablissement des prévisionnels de l'entreprise</li>
                <li>Valorisation de l'entreprise</li>
            </ul>
          </CardJuridique>
          <CardJuridique 
            title={largeurCard >= 477 ? 
              <h3 className='card-juridique-title'>Optimiser votre rémunération</h3> 
            : 
              <h3 className='card-juridique-title'>Optimiser <br />votre rémunération</h3>} 
            icon={optimisation}
          >
            <ul className="card-juridique-content" >
                <li>Organisation et stratégie patrimoniales du chef d’entreprise</li>
                <li>Stratégie familiale : retraite et prévoyance</li>
                <li>Mode de rémunération : prime, dividendes, épargne salariale</li>
                <li>Analyse de votre fiscalité personnelle : ISF, impôt sur les revenus…</li>
                <li>Optimisation du statut social et fiscal du chef d’entreprise</li>
            </ul>
          </CardJuridique>
          <CardJuridique 
            title={<h3 className='card-juridique-title'>Entreprises en difficulté</h3>} 
            icon={entrepriseEnDifficulte}
          >
            <ul className="card-juridique-content" >
                <li>Etablissement de la déclaration de cessation des paiements</li>
                <li>Accompagnement dans le cadre d’un mandat Adhoc, d’une procédure de sauvegarde et d’un redressement judiciaire</li>
                <li>Accompagnement lors de la cession de votre entreprise ou d’une branche d’activité</li>
            </ul>
          </CardJuridique>
          <CardJuridique  
            backgroundColor="true" 
            title={<h3 className='card-juridique-title font-white'>Liquidation amiable</h3>}
            icon={liquidation}
          >
            <ul className="card-juridique-content font-white" >
                <li>Dissolution anticipée</li>
                <li>Suivi des opérations de liquidation</li>
                <li>Etablissement du bilan, du compte de résultat, et du rapport de liquidation</li>
                <li>Formalités de clôture de liquidation</li>
            </ul>
          </CardJuridique>
        </div>
      </section>

      {/* -----------  SECTION 5  ----------- */}
      <section className='questions'>
        <h3>UN NOUVEAU PROJET, UNE QUESTION ?</h3>
        <ButtonContactUs />
      </section>
    </div>
  )
}

export default NosPrestations;